<div class="delivery-widget">
  <div
    class="title-area"
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div class="title">
      {{ 'COMMUNICATIONS.DELIVERY-STATUS' | translate }}
    </div>
    <div class="channels">
      <topo-icon-item-select
        [selectedUId]="selectedChannel.uid"
        [icon]="selectedChannel.icon"
        [label]="selectedChannel.name"
        itemLabel="name"
        itemIcon="icon"
        [items]="channels"
        [isMedium]="true"
        (itemSelected)="selectedChannelChanged($event)"
        [useTopoIcons]="true"></topo-icon-item-select>
    </div>
  </div>
  <div>
    <topo-pie-chart
      [width]="width"
      [height]="width"
      [chartType]="chartType"
      [data]="data"
      [showLegend]="showLegend"
      [showPercentage]="showPercentage"
      [showValues]="showValues"
      (select)="selected($event)"></topo-pie-chart>
  </div>
</div>
